// extracted by mini-css-extract-plugin
export var active = "_aa-7";
export var container = "_aa-0";
export var evenWidth = "_aa-4";
export var large = "_aa-5";
export var outlet = "_aa-8";
export var slide = "_aa-2";
export var small = "_aa-6";
export var tab = "_aa-3";
export var tabs = "_aa-1";